module.exports = __webpack_public_path__ + "img/icon-plus.084ca91c.svg";